var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftSentActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.401 12.2983L7.23929 6.60478C3.88114 3.23483 8.77973 -3.28964 13.401 1.98841C18.0224 -3.27425 22.9672 3.25022 19.5628 6.60478L13.401 12.2983Z",
    fill: "#484888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.2979C0 11.9155 0.310008 11.6055 0.692423 11.6055H3.7733C4.97808 11.6055 6.13366 12.0835 6.98579 12.9348C7.39686 13.3454 7.72107 13.8266 7.94657 14.35L3 14.35C2.64101 14.35 2.35 14.641 2.35 15C2.35 15.359 2.64102 15.65 3 15.65L11.912 15.65C12.4572 15.8339 12.9584 16.1417 13.3731 16.556C14.0808 17.2629 14.4786 18.2219 14.4786 19.222C14.4786 19.61 14.3243 19.9819 14.0499 20.2559C13.7756 20.53 13.4036 20.6838 13.0159 20.6838H0.785348C0.754955 20.6879 0.723936 20.69 0.692423 20.69C0.377333 20.69 0.111571 20.4788 0.0289816 20.1903C0.0101282 20.1273 0 20.0605 0 19.9914C0 19.9718 0.000818507 19.9523 0.00242329 19.9331V12.5C0.00242329 12.4686 0.00452614 12.4377 0.00859887 12.4073C0.00293942 12.3717 0 12.3351 0 12.2979Z",
    fill: "#484888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftSentActive);
export default __webpack_public_path__ + "static/media/gift-sent-active.d2083e0bf31cac266b5a50d50c08478f.svg";
export { ForwardRef as ReactComponent };